import { render, staticRenderFns } from "./ButtonLang.vue?vue&type=template&id=34fb03ef&scoped=true&"
import script from "./ButtonLang.vue?vue&type=script&lang=ts&"
export * from "./ButtonLang.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonLang.vue?vue&type=style&index=0&id=34fb03ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fb03ef",
  null
  
)

export default component.exports